import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { viewBox: "0 0 48 48" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("g", null, [
              _createElementVNode("g", null, [
                _createElementVNode("path", { d: "M0 0h48v48H0z" }),
                _createElementVNode("path", {
                  fill: "#000",
                  d: "M48 35v3H0v-3zm0-13v3H0v-3zm0-13v3H0V9z"
                })
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ])))
}
export default { render: render }